import { simpleSet } from '@r/reducers/utils';

const setCalculationModeAdminSettingsHingesSearchText = simpleSet as
  redux.reducers.calculationMode.adminSettings.projectSettings.materials.hinges.searchText;

export const searchText = setCalculationModeAdminSettingsHingesSearchText(
  'SET_CALCULATION_MODE_ADMIN_SETTINGS_HINGES_SEARCH_TEXT',
  ''
);
